import { BaseEntity } from "@common/ADAPT.Common.Model/base-entity";
import { BreezeModelBuilder } from "@common/ADAPT.Common.Model/breeze-model-builder";
import { ProgressCategory } from "./progress-category";
import { ProgressItemStatus } from "./progress-item-status";

export class ProgressItem extends BaseEntity<ProgressItem> {
    public progressItemId!: number;
    public progressCategoryId!: number;
    public name!: string;
    public ordinal!: number;
    public status!: ProgressItemStatus;
    public date?: Date;
    public comment?: string;

    public progressCategory!: ProgressCategory;
}

export const ProgressItemBreezeModel = new BreezeModelBuilder("ProgressItem", ProgressItem)
    .hasSource()
    .withIdField()
    .isOrganisationEntity()
    .orderBy("ordinal")
    .build();
